import { apiFetchUrl } from '../http/client';
import { ref, onUnmounted, watch } from 'vue';
import type { Ref } from 'vue';

/**
 * Fetches an API image URL with the Bearer token and returns a blob object URL
 * suitable for use in <img :src="...">.
 * Returns an empty string while loading or on error.
 */
export function useAuthImage(apiUrl: Ref<string | null | undefined>) {
    const objectUrl = ref('');
    let currentObjectUrl = '';

    async function load(url: string | null | undefined) {
        if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = '';
            objectUrl.value = '';
        }
        if (!url) {
            return;
        }

        try {
            const blob = await apiFetchUrl(url).then((r) => r.blob());
            currentObjectUrl = URL.createObjectURL(blob);
            objectUrl.value = currentObjectUrl;
        } catch {
            // silently ignore — image just won't show
        }
    }

    watch(apiUrl, (url) => load(url), { immediate: true });

    onUnmounted(() => {
        if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
        }
    });

    return objectUrl;
}
